// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"filter-1"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 8C16.6944 8 20.5 6.88071 20.5 5.5V6L14 14V17C14 19.2091 12.2091 21 10 21V14L3.5 6V5.5C3.5 6.88071 7.30558 8 12 8Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M20.5 5.5C20.5 6.88071 16.6944 8 12 8C7.30558 8 3.5 6.88071 3.5 5.5C3.5 4.11929 7.30558 3 12 3C16.6944 3 20.5 4.11929 20.5 5.5Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M20.5 5.5C20.5 6.88071 16.6944 8 12 8C7.30558 8 3.5 6.88071 3.5 5.5M20.5 5.5C20.5 4.11929 16.6944 3 12 3C7.30558 3 3.5 4.11929 3.5 5.5M20.5 5.5V6L14 14V17C14 19.2091 12.2091 21 10 21V14L3.5 6V5.5","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-filter-1')
export default class Filter1Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'filter-1',
    }
  }
}
